import { Divider, List, ListItem, ListItemText } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import React from 'react';
import Logo from '../../assets/logo/logo_white.png';
import LogoCrop from '../../assets/logo/logo_white_crop.png';
import { SideMenuItem } from '../../models/INav';

const drawerWidth = 320;

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      }
      // marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
  }),
);

interface Props {
  children: any
  open: boolean
  setOpen: (_: boolean) => void
  navItems?: SideMenuItem[]
}

export default function AppSideMenuComponent({
  children,
  open,
  setOpen,
  navItems
}: Props) {
  const classes = useStyles();
  const theme = useTheme();

  const handleItemClick = (item: SideMenuItem) => {
    setOpen(false);
    item.onClick();
  }

  return (
    // <ThemeProvider theme={darkTheme}>
    // <DrawerContext.Provider value={{ setOpen, open }}>
    <div className={classes.root}>

      {/* <CssBaseline /> */}

      <AppBar
        position="fixed"
        className={clsx(classes.appBar, navItems ? {
          [classes.appBarShift]: open,
        } : null)}
      >
        <Toolbar>
          <IconButton
            style={{ color: '#fff' }}
            aria-label="open drawer"
            onClick={() => setOpen(true)}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <img src={LogoCrop} alt="PubPoints logo" style={{ objectFit: 'cover', maxHeight: 60 }} />
          <Typography style={{ color: '#fff' }} variant="h6" noWrap>
            PubPoints
          </Typography>
        </Toolbar>
      </AppBar>
      {
        navItems &&
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
          color="dark"
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={() => setOpen(false)}>
              {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </div>

          <Divider />
          <img src={Logo} alt="PubPoints logo" style={{ objectFit: 'cover', maxHeight: 120 }} />
          <Divider />

          <List>
            {navItems.map((item, index) => (
              <ListItem button key={index}>
                <ListItemText primary={item.label} onClick={() => handleItemClick(item)} />
              </ListItem>
            ))}
          </List>

        </Drawer>}

      <main className={clsx(classes.content, { [classes.contentShift]: open, })} >
        <div className={classes.drawerHeader} />
        {children}
        <div style={{ height: '40px' }} />
      </main>


    </div>
    // </DrawerContext.Provider>

  )
}
